var render = function () {
  var _vm$data$image, _vm$data$image2, _vm$data$image3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGLink', {
    staticClass: "sale-card",
    class: ("sale-card_" + (_vm.size)),
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    staticClass: "sale-card__img",
    attrs: {
      "src": (_vm$data$image = _vm.data.image) === null || _vm$data$image === void 0 ? void 0 : _vm$data$image.x1,
      "srcset": ((_vm$data$image2 = _vm.data.image) === null || _vm$data$image2 === void 0 ? void 0 : _vm$data$image2.x2) && (((_vm$data$image3 = _vm.data.image) === null || _vm$data$image3 === void 0 ? void 0 : _vm$data$image3.x2) + " 2x"),
      "alt": _vm.data.name
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }